<template>
  <div>
    <v-card class="ma-6 pa-6" outlined>
      <DiligenceCheckFilter @onFilterChanged="refresh" />
    </v-card>
    <v-card class="ma-6" outlined>
      <DiligenceCheckTable ref="diligence-data-table" :filters="filters" />
    </v-card>
  </div>
</template>

<script>
// import DiligenceDataTable from './components/DiligenceDataTable'
import DiligenceCheckFilter from './components/DiligenceCheckFilter.vue'
// import StudentBlankView from '@/components/basic/StudentBlankView.vue'
import DiligenceCheckTable from './components/DiligenceCheckTable.vue'

export default {
  components: {
    // DiligenceDataTable,
    DiligenceCheckFilter,
    // StudentBlankView,
    DiligenceCheckTable,
  },
  data() {
    return {
      filters: null,
    }
  },
  methods: {
    refresh(query) {
      this.filters = query
      this.$nextTick(() => {
        this.$refs['diligence-data-table'].searchStudentDiligences()
      })
    },
  },
}
</script>
